import React from 'react';

/**
 * Small segmented control (pill row). options: [{ value, label }].
 */
const Segmented = ({ options, value, onChange, disabled }) => (
  <div style={{
    display: 'inline-flex', gap: 2, padding: 3,
    background: 'var(--bg-elev-2)', borderRadius: 'var(--r-md)',
    border: '1px solid var(--line-soft)', opacity: disabled ? 0.5 : 1,
  }}>
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <button
          key={opt.value}
          type="button"
          onClick={disabled ? undefined : () => onChange(opt.value)}
          style={{
            fontFamily: 'var(--font-sans)', fontSize: 12, fontWeight: 500,
            padding: '5px 10px', borderRadius: 7, border: 'none', lineHeight: 1,
            cursor: disabled ? 'not-allowed' : 'pointer',
            background: active ? 'var(--accent-soft)' : 'transparent',
            color: active ? 'var(--accent)' : 'var(--fg-muted)',
            transition: 'background 120ms, color 120ms',
          }}
          onMouseEnter={(e) => { if (!active && !disabled) e.currentTarget.style.color = 'var(--fg)'; }}
          onMouseLeave={(e) => { if (!active) e.currentTarget.style.color = 'var(--fg-muted)'; }}
        >
          {opt.label}
        </button>
      );
    })}
  </div>
);

export default Segmented;
